<script setup lang="ts">
    import { useCaseSettings } from '@/stores/caseSettings/store';
    import { onBeforeUnmount, ref } from 'vue';
    import { useCtUploadViewModel as useCtUpload } from '@/views/case-settings/upload/ct/useCtUploadViewModel';
    import { useSavingHooks } from '@/views/case-settings/useSavingHooks';

    const store = useCaseSettings();
    const upload = useCtUpload();

    const show = ref(false);

    const { watchSuccessOnSaving } = useSavingHooks();

    const watcher = watchSuccessOnSaving(() => {
        show.value = true;
    });

    onBeforeUnmount(() => {
        watcher();
    });
</script>

<template>
    <app-notification
        v-if="
            show &&
            !upload.hasUploaded &&
            !(store.isError || upload.error) &&
            !store.isCaseDeemedUnsuitable
        "
        title="Your Case Settings were successfully saved!"
        message="You are now able to upload CT scans"
        variant="success"
        :animate-to="true"
    />
</template>
